<template>
  <scroll-view :scroll="true" class="more-flex" v-on:bindscrolltolower="scroll_y()">
    <div v-if="login">
      <van-tabs
        class="more-van-tabs"
        line-height="1px"
        title-active-color="#ff0000"
        @click="clickTap"
        v-if="tablist.length != 0 && tablist[0].name.length != 0"
      >
        <van-tab
          v-for="(item, index) in tablist"
          :key="index"
          :title="item.name"
          :disabled="item.name.length != 0 ? false : true"
        ></van-tab>
      </van-tabs>
      <div class="more-goods-body">
        <goods-view
          v-for="(item, index) in list"
          :key="index"
          :item="item"
          :goodsobject="{ list: list, index: index }"
          @scroll="scroll_y()"
        ></goods-view>
        <loadMore :loadingType="loadingType" style="width: 100%;"></loadMore>
      </div>
    </div>
    <div v-else>
      <loadMore :loadingType="1" style="width: 100%;"></loadMore>
    </div>
  </scroll-view>
</template>

<script>
import { getDir, AlbumPicgetlist, AlbumgetBaseInfo } from '@/request/api.js'
import { Tab, Tabs } from 'vant'
import config from '@/assets/js/config.js'

export default {
  mixins: [config],
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  data () {
    return {
      directory_id: 1298,
      tablist: [],
      tabIndex: 0,
      list: [],
      current_page: 1,
      last_page: 10,
      loadingType: 2,
      login: false,
    }
  },
  created () {
    const param = this.$api.parseUrl()
    const ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.onMenuShare()
      typeof WeixinJSBridge !== 'undefined' && WeixinJSBridge.call('showOptionMenu')
    } else {
      this.login = true
      this.getDir_load()
    }
  },
  methods: {
    async onMenuShare () {
      const _self = this
      const link = `https://huace.9071design.com/wap/#/homeCatalog/morePaeg?alias=${this.$store.state.loginInfo.album_alias}`
      const res = await AlbumgetBaseInfo('')
      this.directory_id = res.data.industry.select_dir_id != 0 ? res.data.industry.select_dir_info.directory_id : 1298
      this.getDir_load()
      this.$store.commit('getRouter', res)
      this.wx_config([
        'checkJsApi',
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'chooseWXPay',
        'updateAppMessageShareData',
        'updateTimelineShareData',
      ]).then((wx) => {
        wx.onMenuShareAppMessage({
          title: res.data.name, // 分享标题
          desc: res.data.share_desc,
          link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: res.data.cover_image_text, // 分享图标
          type: 'link', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success () {
            // 用户点击了分享后执行的回调函数
          },
        })
        wx.onMenuShareTimeline({
          title: res.data.name, // 分享标题
          link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: res.data.cover_image_text, // 分享图标
          success () {
            // 用户确认分享后执行的回调函数
          },
          cancel () {
            // 用户取消分享后执行的回调函数
          },
        })
        wx.updateAppMessageShareData({
          title: res.data.name, // 分享标题
          desc: res.data.share_desc,
          link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: res.data.cover_image_text, // 分享图标
          success () {
            // 设置成功
          },
        })
        wx.updateTimelineShareData({
          title: res.data.name, // 分享标题
          link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: res.data.cover_image_text, // 分享图标
          success () {
            // 设置成功
          },
        })
        _self.login = true
      })
    },
    async getDir_load () {
      let listTength = 2
      const res = await getDir({
        parent_id: this.directory_id,
        albumAlias: this.$store.state.loginInfo.album_alias,
      })
      this.tablist = res.data
      listTength -= this.tablist.length
      if (listTength > 0) {
        for (let i = 0; i < listTength; i++) {
          this.tablist.push({
            name: '',
          })
        }
      }
      this.scroll_y()
    },
    async AlbumPicgetlist_load () {
      const param = {
        directory_id: this.tablist[this.tabIndex].directory_id,
        page: this.current_page,
        directory_pid: this.directory_id,
        albumAlias: this.$store.state.loginInfo.album_alias,
      }
      if (this.loadingType != 1) {
        this.loadingType = 1
        const res = await AlbumPicgetlist(param)
        this.list = this.current_page == 1 ? res.data.data : this.list.concat(res.data.data)
        this.current_page = parseInt(res.data.current_page) + 1
        this.last_page = res.data.last_page
        this.loadingType = this.current_page <= this.last_page ? 0 : 2
      }
    },
    scroll_y () {
      if (this.current_page <= this.last_page) {
        this.AlbumPicgetlist_load()
      }
    },
    clickTap (item) {
      this.tabIndex = item
      this.current_page = 1
      this.last_page = 10
      this.list = []
      this.scroll_y()
    },
  },
};
</script>

<style lang="less">
.more-flex {
  background-color: #efeff4;
  .more-goods-body {
    width: 96%;
    padding: 2%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .more-van-tabs {
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 1000;
    border-bottom: 1px solid #f4f4f4;
  }
}
</style>
